import { render } from "./KoruMenu.vue?vue&type=template&id=48030250"
import script from "./KoruMenu.vue?vue&type=script&lang=js"
export * from "./KoruMenu.vue?vue&type=script&lang=js"

import "./KoruMenu.vue?vue&type=style&index=0&id=48030250&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__